/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Event_AboveInputs */



/**
* | output |
* | --- |
* | "Insert Event (Above)" |
*
* @param {Shortcut_Keys_Name_Insert_Event_AboveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_event_above = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Event_AboveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Event_AboveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un evenement (au-dessus)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis einfügen (oben)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci evento (sopra)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить событие (выше)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar evento (arriba)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入事件（上方）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを挿入（上）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट डालें (ऊपर)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir evento (acima)")
	return /** @type {LocalizedString} */ ("Insert Event (Above)")
});